/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import * as S from './styles';

import { Button } from '../../micros/Button';
import { CardsCarousel } from '../../micros/CardsCarousel';
import { Chips } from '../../micros/Chips';

import { formatGtm } from '../../../utils/formatGtm';

import { SectionCardsCarouselChipsProps } from './types';

export const SectionCardsCarouselChips = ({
	products,
	chips,
	link,
	title,
	textButton,
	size,
	selectedType = 'veiculos',
	marginBottom = 'default',
}: SectionCardsCarouselChipsProps) => {
	const [productsChips, setProductsChips] = useState(products);
	const [selected, setSelected] = useState(selectedType);

	const handleRedirect = () => {
		window.open(link);
	};

	const filterProducts = () => {
		const filteredProducts = products?.filter(
			(product) => product.type === selected
		);
		setProductsChips(filteredProducts);
	};

	const handleSelected = (type: string) => {
		setSelected(type);
	};

	const activeCarousel = productsChips?.length;

	useEffect(() => {
		filterProducts();
	}, [selected]);

	return (
		<S.Container marginBottom={marginBottom}>
			<S.Grid>
				<S.GridItemBox>
					<S.Heading tabIndex={0}>{title}</S.Heading>
				</S.GridItemBox>
				<S.GridItemBox>
					<S.WrapperCarouselChips>
						<S.ContainerCarouselChips role="tablist">
							{chips?.length > 0 &&
								chips.map((item: any, i) => (
									<S.CarouselItem
										key={item.title}
										className="keen-slider__slide"
									>
										<Chips
											mode="light"
											selected={item.type === selected}
											onClick={() => handleSelected(item.type)}
											gtmName={title}
											index={i + 1}
											{...item}
										/>
									</S.CarouselItem>
								))}
						</S.ContainerCarouselChips>
					</S.WrapperCarouselChips>
				</S.GridItemBox>
				<S.GridItem>
					{activeCarousel && (
						<CardsCarousel
							products={productsChips}
							size={size}
							arrows={true}
							mode="light"
							gtmIdentifier={title}
						/>
					)}
				</S.GridItem>
				{textButton && (
					<S.ContainerButton>
						<Button
							variant="insurance"
							styles="ghost"
							size="normal"
							data-testid="button"
							aria-label={`Link para ${textButton}`}
							data-gtm-type="click"
							data-gtm-clicktype="button"
							data-gtm-name={formatGtm(title)}
							data-gtm-subname={formatGtm(textButton)}
							onClick={handleRedirect}
							iconSide="left"
						>
							{textButton}
						</Button>
					</S.ContainerButton>
				)}
			</S.Grid>
		</S.Container>
	);
};
export default SectionCardsCarouselChips;
